import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'phoneNumber4',
      type: 'input',
      label: '手机号后4位',
      placeholder: '请输入手机号后4位',
    },
    {
      field: 'status',
      type: 'select',
      label: '状态',
      placeholder: '请选择状态',
      filterable: true,
      options: [
        {title: '全部', value: ''},
        {title: '已接通', value: '1'},
        {title: '未接通', value: '2'},
        {title: '意向', value: '3'},
        {title: '加个微', value: '4'},
        {title: '加企微', value: '5'},
        {title: '已成交', value: '6'}
      ]
    },
    {
      field: 'caller',
      type: 'select',
      label: '归属人',
      placeholder: '请选择归属人',
      filterable: true,
      options: [],
      clearable: true
    },
    {
      field: 'importTimeSlot',
      type: 'datepicker',
      label: '导入日期',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
